<template>
    <ul class="font-7">
        <span class="title">{{optionsTitle}}</span>
        <li v-for="(option) in options" :key="option[idField]">
            <div class="preset-element" :class="{presetDisabled: option.disabled}"
                 @click="!option.disabled && $emit('dropdownSelectedOption', option)">
                <input type="radio" name="dropdownValue" :value="option[idField]"
                       v-model="selectedItem[idField]" :disabled="option.disabled"/>
                <span class="label truncate">
                    <Tooltip :text="option.tooltip">
                        {{option[displayField]}}
                    </Tooltip>
                </span>
            </div>
        </li>
    </ul>
</template>

<script>
import Tooltip from "components/Tooltip/Tooltip";
export default {
    name: 'RadioLeavesDropdown',
    props: {
        idField: String,
        options: Array,
        selectedItem: Object,
        displayField: String,
        optionsTitle: String
    },
    components: { Tooltip }
};
</script>

<style scoped lang="scss">
    @import 'dropdownStyleGuide';
    @import "~styles/radioButton";

    $paddingLeftElements: 8px;

    .preset-element {
        .label {
            vertical-align: middle;
            line-height: normal;
            padding-left: 8px;
            margin-top: -2px;
        }
        input:disabled + .label {
            color: $light-700;
            cursor: default;
        }
        &.presetDisabled {
            cursor: default;
        }

        overflow: hidden;
        position: relative;
        padding-left: $paddingLeftElements;
        padding-right: $paddingLeftElements;
        white-space: nowrap;
        display: block;
        line-height: 32px;
        cursor: pointer;
        color: $dark-300;

        &:hover {
            background-color: $light-100;
        }
    }

    .title {
        color: $light-700;
        padding: 10px 16px 3px 12px;
        display: block;
    }
</style>
